import React, { useEffect, useState } from "react";
import AdminLayout from "@/components/AdminLayout";
import { adminLive } from "@/lib/api";

export default function AdminLive() {
  const [feed, setFeed] = useState([]);
  useEffect(() => {
    const load = () => adminLive().then(setFeed).catch(() => {});
    load();
    const t = setInterval(load, 8000);
    return () => clearInterval(t);
  }, []);
  return (
    <AdminLayout>
      <h1 className="rbl-h1" style={{ fontSize: 34 }}>Live feed</h1>
      <p className="rbl-intro">Most recent worksheet submissions & quiz attempts (auto-refreshes).</p>
      <div style={{ marginTop: 18 }} data-testid="live-feed">
        {feed.length === 0 && <p style={{ color: "var(--muted)" }}>No activity yet.</p>}
        {feed.map((f, i) => (
          <div key={i} className="rbl-list-item">
            <div>
              <span className="rbl-badge muted" style={{ marginRight: 8 }}>{f.type === "quiz" ? "QUIZ" : "WORKSHEET"}</span>
              <strong>{f.participant_name}</strong> {f.title ? `— ${f.title}` : ""} {f.type === "quiz" ? `· ${f.score}%` : ""}
            </div>
            <span style={{ color: "var(--muted)", fontSize: 12 }}>{f.at ? new Date(f.at).toLocaleString() : ""}</span>
          </div>
        ))}
      </div>
    </AdminLayout>
  );
}
